import { useEffect } from 'react';
import { useAlgoliaDataContext } from '../hooks/useAlgoliaDataContext';
import { useSearchParams } from 'react-router-dom';
import { SEARCH_PARAM_KEY_PAGE_NUMBER } from '../constants/searchParamKeys';
import { dlDispatchAmplEvent } from '../../events/dl.dispatchAmplEvent';
export const AmplViewLastPage = () => {
    const { nbPages } = useAlgoliaDataContext();
    const [searchParams] = useSearchParams();
    const page = +(searchParams.get(SEARCH_PARAM_KEY_PAGE_NUMBER) ?? 1);
    useEffect(() => {
        nbPages === page && dlDispatchAmplEvent('End of collection reached');
    }, [nbPages]);
    return null;
};
